import { render, staticRenderFns } from "./global-forms-content-editor.vue?vue&type=template&id=98ef1338"
import script from "./global-forms-content-editor.vue?vue&type=script&lang=js"
export * from "./global-forms-content-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports